import i18n from 'i18next';
import HttpApi, { type HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
    .use(HttpApi)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init<HttpBackendOptions>({
        backend: {
            loadPath: '/api/resources/translations',
        },
        lng: 'xx', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    })
    .catch((e) => console.error(`⛔ i18n failed`, e));

export default i18n;
